import { makeStyles } from '@material-ui/core';
import colours from '../../../abstracts/colours';

const useStyles = makeStyles({
  root: {
    '&.Mui-focusVisible svg': {
      outline: `2px auto ${colours.black}`,
      outlineOffset: 1,
    },
  },
});

export default useStyles;
